import PropTypes from 'prop-types';
import i18n from './i18n';
import langConstant from './langConstant';

export const i18nPimsChangeLanguage = lang => {
  const _lang = lang.toLowerCase();
  i18n.init({
    resources:
      _lang.includes('pg') || _lang.includes('pp')
        ? langConstant.resourcesGov
        : langConstant.isKnox
        ? langConstant.resourcesKnox
        : langConstant.resourcesBrity,
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    detection: { order: ['cookieDetector', 'navigatorDetector'], lookupCookie: 'saveLanguage' },
    fallbackLng: 'en',
    ns: ['contacts'],
  });
};

i18nPimsChangeLanguage.propTypes = {
  lang: PropTypes.string,
};

i18nPimsChangeLanguage.defaultProps = {
  lang: 'init',
};

export default i18nPimsChangeLanguage;
